import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { catchError, filter, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import * as moment from 'moment';
@Injectable({
    providedIn: 'root'
})
export class MessagesService {
    
    constructor( private _httpClient: HttpClient ){

    }


    messages(): Observable<any> {
        // Return the response
        return this._httpClient.get('/api/notifications/list')
            .pipe(
                map( (messages: any) => {
                        const response = [];
                        messages.forEach((message: any) => {
                                response.push( {
                                    id         : message.id,
                                    image      : 'assets/images/logo/logo.png',
                                    title      : message.tipo__description,
                                    description: message.tipo__txt,
                                    time       : moment(message.created),
                                    read       : message.read
                                });                                            
                        });
                        return response;
                    }
                ),
                catchError(err => of([])),
            );
    }

    
    
}
